import React from 'react';
import './InstaReelsCarousel.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// ✅ Import thumbnail images
import reel1 from '../assets/galimg/insta-reels-1.png';
import reel2 from '../assets/galimg/insta-reels-2.png';
import reel3 from '../assets/galimg/insta-reels-3.png';
import reel4 from '../assets/galimg/insta-reels-4.png';
import reel5 from '../assets/galimg/insta-reels-1.png';
import reel6 from '../assets/galimg/insta-reels-2.png';
import reel7 from '../assets/galimg/insta-reels-3.png';
import reel8 from '../assets/galimg/insta-reels-4.png';

// ✅ Full reel list
const reelVideos = [
  { id: 'reel1', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel1 },
  { id: 'reel2', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel2 },
  { id: 'reel3', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel3 },
  { id: 'reel4', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel4 },
  { id: 'reel5', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel5 },
  { id: 'reel6', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel6 },
  { id: 'reel7', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel7 },
  { id: 'reel8', video: 'https://www.instagram.com/reel/DKSznSQtAqP/?hl=en', thumbnail: reel8 },
];

// ✅ Group into chunks of 4 per slide
const chunkedSlides = [];
for (let i = 0; i < reelVideos.length; i += 4) {
  chunkedSlides.push(reelVideos.slice(i, i + 4));
}

const InstaReelsCarousel = () => {
  return (
    <div className="insta-carousel-wrapper">
      <h2 className="insta-carousel-title">Insta Reel – Videos</h2>
      <Swiper
        spaceBetween={30}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className="insta-reels-swiper"
      >
        {chunkedSlides.map((group, index) => (
          <SwiperSlide key={index}>
            <div className="reels-row">
              {group.map((item) => (
                <div className="insta-reel-card" key={item.id}>
                  <a href={item.video} target="_blank" rel="noopener noreferrer">
                    <img src={item.thumbnail} alt={`Reel ${item.id}`} />
                  </a>
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default InstaReelsCarousel;
